import { PhysicalProductInterface } from '@systemeio/types'
import { DEFAULT_PRODUCTS_API, PRODUCTS_API } from 'modules/products/api/product-api'
import { ProductApiInterface } from 'modules/products/types/product-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface'
import { baseFetcher } from 'shared/utils/http-client'
import useSWR from 'swr'

export function useProducts({ limit, pagination }: SwrPaginationInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ProductApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: products, mutate } = useSWR(() => {
    if (user && pagination.startFromId === undefined && limit) {
      return `${PRODUCTS_API}/list?pagination[limit]=${limit}&filter[searchBy]`
    } else if (user && pagination.startFromId && limit) {
      return `${PRODUCTS_API}/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}&filter[searchBy]`
    }
  }, fetcher)

  const { data: counter } = useSWR<CountInterface>(() => {
    if (user) {
      return `${PRODUCTS_API}/count`
    }
    return null
  }, baseFetcher)

  return { products, mutate, counter }
}

export function useProduct(id?: number) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, PhysicalProductInterface>({
    method: RequestMethodsEnum.get,
  })

  return useSWR<PhysicalProductInterface>(() => {
    if (user && id) {
      return `${PRODUCTS_API}/${id}`
    }
    return null
  }, fetcher)
}

export function useProductDefaultValues() {
  const { user } = useUser()

  return useSWR<Pick<PhysicalProductInterface, 'currency' | 'tax'>>(() => {
    if (user) {
      return `${DEFAULT_PRODUCTS_API}`
    }
    return null
  }, baseFetcher)
}
